export default __webpack_public_path__ + "img/android-icon-192x192.png";